import toastr from 'toastr';
import '../assets/styles/toastr.scss';

toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-bottom-full-width',
    preventDuplicates: true,
    onclick: null,
    showDuration: '2000',
    hideDuration: '2000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
};
